import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// import { getToken } from '@/utils/auth'

// create an axios instance

// let url = 'http://183.136.238.165/'
// const service = axios.create({
//   // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   baseURL: process.env.API_HOST,
//   // withCredentials: true, // 当跨域请求时发送cookie
//   timeout: 5000000 // 请求超时
// })
// // request interceptor
// service.interceptors.request.use(
//   config => {
//   //     config.headers['Content-Type'] = 'application/json'
//     return config
//   },
//   error => {
//     // 处理请求错误
//     console.log(error) // for debug
//     return Promise.reject(error)
//   }
// )
// // response interceptor
// service.interceptors.response.use(
//   /**
//    * If you want to get http information such as headers or status
//    * Please return  response => response
//   */

//   /**
//    * Determine the request status by custom code
//    * Here is just an example
//    * You can also judge the status by HTTP Status Code
//    */
//   response => {
//     const res = response.data
//     // if (res.status === 0) {
//     //   let path = window.location.href
//     //   let data = {
//     //     message: response.config.data,
//     //     info: response.config.url,
//     //     path: path,
//     //     errortype: 1
//     //   }
//     //   $.ajax({
//     //     type: 'post',
//     //     url: 'https://card.heidutech.com/api/coon/loginsert',
//     //     data: data,
//     //     dataType: 'json',
//     //     success: function (res) {
//     //       console.log('上报成功')
//     //     }
//     //   })
//     // }
//     if (res.Result === true || res.status === 1) {
//       res.token = response.headers.token
//       return res
//     }
//     // 如果code不是20000，则判断为错误。
//     if (response.status !== 200) {
//       // Message({
//       //   message: res.message || 'Error',
//       //   type: 'error',
//       //   duration: 5 * 1000
//       // })
//       // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
//       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//         // to re-login
//         MessageBox.confirm('您已注销，您可以取消停留在此页，或重新登录', '确认注销', {
//           confirmButtonText: 'Re-Login',
//           cancelButtonText: 'Cancel',
//           type: 'warning'
//         }).then(() => {
//           // store.dispatch('user/resetToken').then(() => {
//           //   location.reload()
//           // })
//         })
//       }
//       return Promise.reject(new Error(res.message || 'Error'))
//     } else {
//       return res
//     }
//   },
//   error => {
//     // console.log('err' + error) // for debug
//     // Message({
//     //   message: error.message,
//     //   type: 'error',
//     //   duration: 5 * 1000
//     // })
//     return Promise.reject(error)
//   }
// )


const service = (obj = {data,url,method}) => {
  let instance = axios.create({
    baseURL:  process.env.VUE_APP_BASE_API,
    // method: 'POST',
    method: obj.method || 'POST',
    responseType: 'json',
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    }
  })
  // response过滤
  instance.interceptors.response.use(function (response) {
    const res = response.data|| {}
    
    if (res.Result === true || res.status === 1) {
      res.token = response.headers.token
      return res
    }
    // 如果code不是20000，则判断为错误。
    if (response.status !== 200) {
      
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('您已注销，您可以取消停留在此页，或重新登录', '确认注销', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  }, function (err) {
    return Promise.reject(err)
  })
  instance.interceptors.request.use(
    config => {
      config.url = obj.url
      config.data =  obj.data
      config.headers['Content-Type'] = 'application/json'
      return config
    },
    error => {
      // 处理请求错误
      console.log(error) // for debug
      return Promise.reject(error)
    }
  )
  return instance.request({
    // ^0.19.0版本会将create中配置的method方法转为get 所以在此重新指定请求方法
    method:obj.method || 'POST',
    // url,
    // data,
    // data: qs.stringify({
    //   cmd,
    //   data: JSON.stringify(data),
    //   version: 1
    // })
  })
}
// 特殊情况下，可能还需要使用axios
// export default {
//   request,
//   axios
// }
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js